import React,{useEffect,useState} from "react";
import CustomHeading from "../../../constants/CustomHeading";
import CustomDropdown from '../../../constants/CustomDropdown';
import CustomFilter from '../../../constants/CustomFilter';
import {getdepartmentData,getCurriculumData,getProgramData,getStackholderData,setStackholderData} from "../../../redux/actions/dataAction";
import {connect} from 'react-redux';
import CustomTableWithAll from "../../../constants/CustomTableWithAll";
import CustomButton from "../../../constants/CustomButton";
import CustomInput from "../../../constants/CustomInput"
import {  Formik, Form} from 'formik';
import * as Yup from 'yup';

const stakeholderSchema = Yup.object().shape({
  program: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  department: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  curriculum: Yup.string()
    .required('Required'),
  group: Yup.string()
    .required('Required'),
 
});

const ManageStakeholder = (props) => {
  const [filterData,setFilterData]=useState([]);
  const [isVisibleForm,setIsVisibleForm]=useState(false)
    useEffect(()=>{
        props.getdepartmentData()
        props.getCurriculumData()
        props.getProgramData()
        props.getStackholderData()
      },[])
      const [filter,setFilter]=useState({
        stackholder:'Select Stakeholders Group',
        department:'Select Department',
        program:'Select Program',
        curriculum:'Select Curriculum'
      })
      const handleChange=(event)=>{
        setFilter(({...filter,[event.target.id]:event.target.value})) 
      
      }

      const FilterTableData=()=>{
        let data=CustomFilter(props?.stackholder?.data,[
          {value:filter.stackholder,label:'group',initial_value:'Select Stakeholders Group'},
          {value:filter.department,label:'department',initial_value:'Select Department'},
          {value:filter.program,label:'program',initial_value:'Select Program'},
          {value:filter.curriculum,label:'curriculum',initial_value:'Select Curriculum'},
        ]);
        setFilterData(data);
      }
      useEffect(()=>{
        FilterTableData()
      },[props?.stackholder?.data,filter])

    const columns=[
      {title:'First Name',field:'first_name'},
      {title:'Last Name',field:'last_name'},
      {title:'Email',field:'email'},
      {title:'Contact no.',field:'contact_number'},
      {title:'Created by',field:'created_by'},
    ]
  return (
  <div className="customContainer">
      <CustomHeading title="Stakeholder List"/>
      <div className="row my-0" >
          <div className="col-md-6">
           <CustomDropdown
           id="stackholder"
            label="Stakeholders Group :"
            data={[ {value: 'Employer or Industry'},
            {value: 'Alumni'},
            {value:'Professional Bodies'},
            {value: 'Others'},
            {value: 'Patent'}]}
            notDefaultOption
            defaultOption={"Select Stakeholders Group"}
            onChange={handleChange}
            />
          </div>
          <div className="col-md-2"></div>
          <div className="col-md-4">
          <CustomDropdown
            id="department"
            label="Department :"
            data={props?.department?.data?.map(d=>{
                return(
                    {value:d.name}
                )
            })}
            notDefaultOption
            defaultOption={"Select Department"}
            onChange={handleChange}
            />
          </div>
      </div>
      <div className="row my-0">
          <div className="col-md-4">
           <CustomDropdown
           id="program"
            label="Program :"
            data={props?.program?.data?.map(d=>{
              return(
                  {value:d.title}
              )
          })}
            notDefaultOption
            defaultOption={"Select Program"}
            onChange={handleChange}
            />
          </div>
          <div className="col-md-4"></div>
          <div className="col-md-4">
          <CustomDropdown
          id="curriculum"
            label="Curriculum :"
            data={props?.curriculums?.data?.map(d=>{
                return(
                    {value:d.name}
                )
            })}
            notDefaultOption
            defaultOption={"Select Curriculum"}
            onChange={handleChange}
            />
          </div>
      </div>
      <CustomTableWithAll data={filterData} title={"Stakeholder List"} buttonRequired={false} columns={columns} api="/api/stakeholder/" identify="Stakeholder List" />
      <div>
            <CustomButton label="Add Topic" onClick={()=>setIsVisibleForm(true)}/>
      </div>

       {/* form */}

      {isVisibleForm && <div>
        <CustomHeading title="Add Stakeholder"/>
        <Formik
       initialValues={{
        department: '',
        program: '',
        curriculum: '',
        group:'',
        first_name:'',
        last_name:'',
        email:'',
        contact_number:'',
        created_at:new Date().toString(),
        updated_at:new Date().toString(),
        created_by:'admin'
       }}
       validationSchema={stakeholderSchema}
       onSubmit={values => {
         console.log(values)
          props.setStackholderData(values);
          setIsVisibleForm(false);
          props.history.push('/survey/manage-stakeholder')
       }}
     >
       {({ errors, touched,handleChange,handleSubmit }) => (
         <Form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
                <CustomInput
              type={'text'}
              id="department"
              label={'Department:'}
              onChange={handleChange('department')}
              errorText={
                errors.department && touched.department ?errors.department :null
              }
            />
            </div>
            <div className="col-md-6">
              <CustomInput
              type={'text'}
              id="program"
              label={'Program :'}
              onChange={handleChange('program')}
              errorText={
                errors.program && touched.program ?errors.program :null
              }
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
                <CustomInput
              type={'text'}
              id="Curriculum"
              label={'Curriculum :'}
              onChange={handleChange('curriculum')}
              errorText={
                errors.curriculum && touched.curriculum ?errors.curriculum :null
              }
            />
            </div>
            <div className="col-md-6">
              <CustomInput
              type={'text'}
              id="Stakeholder"
              label={'Stakeholder Group :'}
              onChange={handleChange('group')}
              errorText={
                errors.group && touched.group ?errors.group :null
              }
            />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
                <CustomInput
              type={'text'}
              id="First"
              label={'First Name :'}
              onChange={handleChange('first_name')}
            />
            </div>
            <div className="col-md-6">
              <CustomInput
              type={'text'}
              id="Last"
              label={'Last Name :'}
              onChange={handleChange('last_name')}
            />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
                <CustomInput
              type={'text'}
              id="Contact"
              label={'Contact Number :'}
              onChange={handleChange('contact_number')}
            />
            </div>
            <div className="col-md-6">
              <CustomInput
              type={'text'}
              id="Email"
              label={'Email Id :'}
              onChange={handleChange('email')}
            />
            </div>
          </div>
          <CustomButton type="submit" label="Save" isIcon/>
         </Form>
       )}
     </Formik>

        </div>}
  </div>
  );
};
const mapActionWithProps = {
    getdepartmentData,
    getCurriculumData,
    getProgramData,
    getStackholderData,
    setStackholderData,
  }
  
  const mapStateWithProps = (state)=>(
    {
      department:state.data.department,
      curriculums:state.data.curriculums,
      program:state.data.program,
      stackholder:state.data.stackholder,
    }
  )
  export default connect(mapStateWithProps,mapActionWithProps)(ManageStakeholder);
